import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "alt"],
      _excluded2 = ["children", "alt"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { styled } from '@linaria/react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledButton = /*#__PURE__*/styled("button")({
  name: "StyledButton",
  class: "s16vnj57",
  vars: {
    "s16vnj57-0": [props => props.size ? props.size : 'var(--font-size-2sm)'],
    "s16vnj57-1": [() => "url(/img/noise-light.svg), var(--clr-blue)"]
  }
});
export const Button = _ref => {
  let {
    children,
    alt = ''
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(StyledButton, _objectSpread(_objectSpread({}, props), {}, {
    className: clsx('button', props.className || ''),
    children: [/*#__PURE__*/_jsx("span", {
      className: "toggle-size",
      children: children
    }), /*#__PURE__*/_jsx("span", {
      className: "label",
      children: alt || children
    })]
  }));
};
export const StyledEmojiButton = /*#__PURE__*/styled(StyledButton)({
  name: "StyledEmojiButton",
  class: "s1o8snp4"
});
export const EmojiButton = _ref2 => {
  let {
    children,
    alt = ''
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsxs(StyledEmojiButton, _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "toggle-size",
      children: children
    }), /*#__PURE__*/_jsx("span", {
      className: "label",
      children: alt || children
    })]
  }));
};

require("./Button.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Button.tsx");